import { KPI_VALUE_PERCENT } from '@/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerEngagementRate: KpiType<typeof MediaViewerKpiLoader> = {
    name: 'kpi.tiktok.engagement_rate',
    id: 'engagement_rate',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    mergedData: true,
    loader: MediaViewerKpiLoader
};
